export const ADD_ITEM = 'ADD_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const SET_DEBT_ACTION = 'SET_DEBT_ACTION'
